module.exports = __webpack_public_path__ + "static/media/favebiz-deal.a77376ba.jpg";